// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body[data-v-13464069],html[data-v-13464069]{height:100%}.auth-container[data-v-13464069]{background-color:rgba(0,204,255,.6);height:100%;width:100%;position:absolute;background-position:50%;background-repeat:no-repeat;background-size:cover}", ""]);
// Exports
module.exports = exports;
